import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/Axios/axios-instance';
import { UserStatistics } from '../../domain/User';

export const fetchUserStats = createAsyncThunk('user/statistics', async (userId: number) => {
  const response = await axiosInstance.get<UserStatistics>(`/users/${userId}/statistics`);
  return response.data;
});
